import { VolunteerAsJpEmail } from './VolunteerAsJpEmail';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { WillsEmailFormatterService } from './willsemailformatter.service';
import { WillsEmail } from './willsEmail';
import { AppConfig } from '../../app.config';
import { Log } from '../../shared/log';
import { AuthHttpWithRetry } from '../../services/http/auth-http-with-retry';

const log = new Log('NotificationService');

@Injectable()
export class NotificationService {
  private serverUrl;

  constructor(
      private authHttp: AuthHttpWithRetry,
      private appConfig: AppConfig,
      private willsEmailFormatterService: WillsEmailFormatterService
  ) {
    this.serverUrl = appConfig.getValue('endPoint');
  }

  addCustomerNotification(model: WillsEmail, subject: string): Promise<Object> {
    const email = this.willsEmailFormatterService.formatWillsEMail(model);

    return this.authHttp.post(this.serverUrl + 'addnotification', { email, subject })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  sendVolunteerAsJpEmail(model: VolunteerAsJpEmail): Promise<Object> {
    const messageDetails = {
      'notificationType': 'volunteerAsJpNotification',
      'email':     model.getEmailBody(),
      'subject':   model.getSubject()
    };

    return this.authHttp.post(this.serverUrl + 'addnotification', messageDetails)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    const body = res.json();
    return body.data || body || {};
  }

  private handleError(error: any): Promise<any> {
    log.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./app/services/notification/notification.service.ts